import { Modal, ModalClose, ModalDialog } from '@mui/joy';

export function ErrorModal(props: {
  error: string | null;
  setError: (e: string | null) => void;
}) {
  return (
    <Modal open={!!props.error} onClose={() => props.setError(null)}>
      <ModalDialog variant="outlined" sx={{ width: 550 }}>
        <ModalClose size="lg" />
        <div className="flex flex-col items-start gap-2 p-3">
          <div>
            An error occurred. Please try again or contact{' '}
            <a
              href="mailto:support@langchain.dev"
              className="text-brand-green-400 hover:text-brand-green-400"
            >
              support@langchain.dev
            </a>{' '}
            for further assistance.
          </div>
          <div className="text-error">{props.error}</div>
        </div>
      </ModalDialog>
    </Modal>
  );
}
